import React, { useState } from "react";

const Header1 = () => {
  const [isOpen, setIsOpen] = useState(false);

return (
    <header className="fixed top-0 w-full z-50 backdrop-blur bg-white/90 border-b border-gray-200">
        {/* <div className="max-w-7xl mx-auto px-6"> */}
        <div className="container-custom">
            <div className="flex justify-between items-center h-16 md:h-20">
                {/* Logo */}
                <a href="/" className="flex items-center gap-5" data-testid="logo-link">
                    <img
                        // src="https://s3-cc-prod.s3.ap-south-1.amazonaws.com/tistl/mycafeconnect.jpg"
                        src="https://s3-cc-prod.s3.ap-south-1.amazonaws.com/tistl/tistl_logo_transparent.png"
                        alt="Logo"
                        className="h-10 md:h-12 w-auto"
                    />
                    {/* <span className="text-lg font-semibold text-gray-900">
                        MyCafe Connect
                    </span> */}
                </a>

                {/* Desktop Menu */}
                <nav className="hidden md:flex items-center gap-8">
                    <a
                        href="/faqs"
                        className="relative text-gray-700 hover:text-blue-600 font-medium transition"
                    >
                        FAQs
                        <span className="absolute left-0 -bottom-1 w-0 h-[2px] bg-gradient-to-r from-blue-600 to-cyan-400 transition-all duration-300 group-hover:w-full"></span>
                    </a>

                    <a
                        href="/terms-conditions"
                        className="text-gray-700 hover:text-blue-600 font-medium transition"
                    >
                        Terms
                    </a>

                    <a
                        href="/privacy-policy"
                        className="text-gray-700 hover:text-blue-600 font-medium transition"
                    >
                        Privacy
                    </a>

                    <a
                        href="/"
                        className="px-5 py-2 rounded-full bg-gradient-to-r from-blue-600 to-cyan-400 text-white font-medium shadow hover:opacity-90 transition"
                    >
                        Home
                    </a>
                </nav>

                {/* Mobile Button */}
                <button
                    onClick={() => setIsOpen(!isOpen)}
                    className="md:hidden text-gray-700"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-7 w-7"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        {isOpen ? (
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M6 18L18 6M6 6l12 12"
                            />
                        ) : (
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M4 6h16M4 12h16M4 18h16"
                            />
                        )}
                    </svg>
                </button>
            </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
            <div className="md:hidden bg-white border-t border-gray-200 shadow">
                <div className="flex flex-col px-6 py-4 gap-4">
                    <a href="/api/faq" className="text-gray-700 hover:text-blue-600">
                        FAQs
                    </a>
                    <a
                        href="/api/terms-conditions"
                        className="text-gray-700 hover:text-blue-600"
                    >
                        Terms
                    </a>
                    <a
                        href="/api/privacy-policy"
                        className="text-gray-700 hover:text-blue-600"
                    >
                        Privacy
                    </a>
                    <a
                        href="/"
                        className="px-4 py-2 rounded-full bg-gradient-to-r from-blue-600 to-cyan-400 text-white text-center"
                    >
                        Home
                    </a>
                </div>
            </div>
        )}
    </header>
);
};

export default Header1;
